import React from 'react';
export var NoAvailableDataComponent = function NoAvailableDataComponent(_ref) {
  var _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline;
  if (inline) {
    return React.createElement("span", null, "n/a");
  }
  return React.createElement("div", null, "-");
};
export var InlineNoAvailableDataComponent = function InlineNoAvailableDataComponent() {
  return React.createElement(NoAvailableDataComponent, {
    inline: true
  });
};